import { createRouter, createWebHistory } from 'vue-router'

// Basic route structure - unplugin-vue-router disabled due to parsing issues
// Routes will be manually defined here
const routes = [
  {
    path: '/',
    redirect: '/superadmin',
  },
  {
    path: '/superadmin',
    name: 'superadmin',
    component: () => import('@/pages/superadmin/index.vue'),
    meta: { auth: 'sa', layout: 'default' },
  },
  {
    path: '/superadmin/login',
    name: 'superadmin-login',
    component: () => import('@/pages/superadmin/login.vue'),
    meta: { layout: 'blank', public: true },
  },
  {
    path: '/superadmin/tenants',
    name: 'superadmin-tenants',
    component: () => import('@/pages/superadmin/tenants/index.vue'),
    meta: { auth: 'sa', layout: 'default' },
  },
  {
    path: '/superadmin/tenants/create',
    name: 'superadmin-tenants-create',
    component: () => import('@/pages/superadmin/tenants/create.vue'),
    meta: { auth: 'sa', layout: 'default' },
  },
  {
    path: '/superadmin/tenants/:id',
    name: 'superadmin-tenants-id',
    component: () => import('@/pages/superadmin/tenants/[id].vue'),
    meta: { auth: 'sa', layout: 'default' },
  },
  {
    path: '/superadmin/tenants/:id/modules',
    name: 'superadmin-tenants-id-modules',
    component: () => import('@/pages/superadmin/tenants/[id]-modules.vue'),
    meta: { auth: 'sa', layout: 'default' },
  },
  {
    path: '/superadmin/plans',
    name: 'superadmin-plans',
    component: () => import('@/pages/superadmin/plans/index.vue'),
    meta: { auth: 'sa', layout: 'default' },
  },
  {
    path: '/superadmin/users',
    name: 'superadmin-users',
    component: () => import('@/pages/superadmin/users/index.vue'),
    meta: { auth: 'sa', layout: 'default' },
  },
  {
    path: '/superadmin/analytics',
    name: 'superadmin-analytics',
    component: () => import('@/pages/superadmin/analytics.vue'),
    meta: { auth: 'sa', layout: 'default' },
  },
  {
    path: '/superadmin/audit',
    name: 'superadmin-audit',
    component: () => import('@/pages/superadmin/audit.vue'),
    meta: { auth: 'sa', layout: 'default' },
  },
  {
    path: '/superadmin/billing',
    name: 'superadmin-billing',
    component: () => import('@/pages/superadmin/billing/index.vue'),
    meta: { auth: 'sa', layout: 'default' },
  },
  {
    path: '/superadmin/billing-periods',
    name: 'superadmin-billing-periods',
    component: () => import('@/pages/superadmin/billing-periods/index.vue'),
    meta: { auth: 'sa', layout: 'default' },
  },
  {
    path: '/superadmin/billing-module-prices',
    name: 'superadmin-billing-module-prices',
    component: () => import('@/pages/superadmin/billing-module-prices/index.vue'),
    meta: { auth: 'sa', layout: 'default' },
  },
  {
    path: '/superadmin/billing-overdue',
    name: 'superadmin-billing-overdue',
    component: () => import('@/pages/superadmin/billing/overdue.vue'),
    meta: { auth: 'sa', layout: 'default' },
  },
  {
    path: '/superadmin/cancellations',
    name: 'superadmin-cancellations',
    component: () => import('@/pages/superadmin/cancellations.vue'),
    meta: { auth: 'sa', layout: 'default' },
  },
  {
    path: '/superadmin/profile',
    name: 'superadmin-profile',
    component: () => import('@/pages/superadmin/profile.vue'),
    meta: { auth: 'sa', layout: 'default' },
  },
  {
    path: '/superadmin/system',
    name: 'superadmin-system',
    component: () => import('@/pages/superadmin/system.vue'),
    meta: { auth: 'sa', layout: 'default' },
  },
  {
    path: '/tenant/login',
    name: 'tenant-login',
    component: () => import('@/pages/tenant/login.vue'),
    meta: { layout: 'blank', public: true },
  },
  {
    path: '/tenant',
    name: 'tenant',
    component: () => import('@/pages/tenant/index.vue'),
    meta: { auth: 'tenant', layout: 'default' },
  },
  // ── MENU MODULE ── (ALL TEMPLATE FIXES COMPLETED - NOW ENABLED)
  {
    path: '/tenant/menu/categories',
    name: 'tenant-menu-categories',
    component: () => import('@/pages/tenant/menu/categories.vue'),
    meta: { auth: 'tenant', layout: 'default' },
  },
  {
    path: '/tenant/menu/items',
    name: 'tenant-menu-items',
    component: () => import('@/pages/tenant/menu/items/index.vue'),
    meta: { auth: 'tenant', layout: 'default' },
  },
  {
    path: '/tenant/menu/items/create',
    name: 'tenant-menu-items-create',
    component: () => import('@/pages/tenant/menu/items/create.vue'),
    meta: { auth: 'tenant', layout: 'default' },
  },
  {
    path: '/tenant/menu/items/:id',
    name: 'tenant-menu-items-id',
    component: () => import('@/pages/tenant/menu/items/[id].vue'),
    meta: { auth: 'tenant', layout: 'default' },
  },
  {
    path: '/tenant/menu/modifiers',
    name: 'tenant-menu-modifiers',
    component: () => import('@/pages/tenant/menu/modifiers.vue'),
    meta: { auth: 'tenant', layout: 'default' },
  },
  {
    path: '/tenant/menu/combos',
    name: 'tenant-menu-combos',
    component: () => import('@/pages/tenant/menu/combos.vue'),
    meta: { auth: 'tenant', layout: 'default' },
  },
  {
    path: '/tenant/menu/happy-hour',
    name: 'tenant-menu-happy-hour',
    component: () => import('@/pages/tenant/menu/happy-hour.vue'),
    meta: { auth: 'tenant', layout: 'default' },
  },
  // ── OPERATIONS MODULE ────────────────────────────────
  {
    path: '/tenant/terminals',
    name: 'tenant-terminals',
    component: () => import('@/pages/tenant/terminals/index.vue'),
    meta: { auth: 'tenant', layout: 'default' },
  },
  {
    path: '/tenant/terminals/:id',
    name: 'tenant-terminals-id',
    component: () => import('@/pages/tenant/terminals/[id]/index.vue'),
    meta: { auth: 'tenant', layout: 'default' },
  },
  {
    path: '/tenant/terminals/:id/settings',
    name: 'tenant-terminals-id-settings',
    component: () => import('@/pages/tenant/terminals/[id]/settings.vue'),
    meta: { auth: 'tenant', layout: 'default' },
  },
  {
    path: '/tenant/orders',
    name: 'tenant-orders',
    component: () => import('@/pages/tenant/orders/index.vue'),
    meta: { auth: 'tenant', layout: 'default' },
  },
  {
    path: '/tenant/dine-in/floor',
    name: 'tenant-dine-in-floor',
    component: () => import('@/pages/tenant/dine-in/floor.vue'),
    meta: { auth: 'tenant', layout: 'default' },
  },
  {
    path: '/tenant/dine-in/reservations',
    name: 'tenant-dine-in-reservations',
    component: () => import('@/pages/tenant/dine-in/reservations.vue'),
    meta: { auth: 'tenant', layout: 'default' },
  },
  {
    path: '/tenant/dine-in/waitlist',
    name: 'tenant-dine-in-waitlist',
    component: () => import('@/pages/tenant/dine-in/waitlist.vue'),
    meta: { auth: 'tenant', layout: 'default' },
  },
  {
    path: '/tenant/qr',
    name: 'tenant-qr',
    component: () => import('@/pages/tenant/qr/index.vue'),
    meta: { auth: 'tenant', layout: 'default' },
  },
  {
    path: '/tenant/waiter',
    name: 'tenant-waiter',
    component: () => import('@/pages/tenant/waiter/index.vue'),
    meta: { auth: 'tenant', layout: 'default' },
  },
  {
    path: '/tenant/kitchen/stations',
    name: 'tenant-kitchen-stations',
    component: () => import('@/pages/tenant/kitchen/stations.vue'),
    meta: { auth: 'tenant', layout: 'default' },
  },
  {
    path: '/tenant/checklists',
    name: 'tenant-checklists',
    component: () => import('@/pages/tenant/checklists/index.vue'),
    meta: { auth: 'tenant', layout: 'default' },
  },
  {
    path: '/tenant/checklists/runs',
    name: 'tenant-checklists-runs',
    component: () => import('@/pages/tenant/checklists/runs.vue'),
    meta: { auth: 'tenant', layout: 'default' },
  },
  // ── INVENTORY MODULE ────────────────────────────────
  {
    path: '/tenant/inventory/stock',
    name: 'tenant-inventory-stock',
    component: () => import('@/pages/tenant/inventory/stock.vue'),
    meta: { auth: 'tenant', layout: 'default' },
  },
  {
    path: '/tenant/inventory/ingredients',
    name: 'tenant-inventory-ingredients',
    component: () => import('@/pages/tenant/inventory/ingredients.vue'),
    meta: { auth: 'tenant', layout: 'default' },
  },
  {
    path: '/tenant/inventory/recipes',
    name: 'tenant-inventory-recipes',
    component: () => import('@/pages/tenant/inventory/recipes.vue'),
    meta: { auth: 'tenant', layout: 'default' },
  },
  {
    path: '/tenant/inventory/stocktake',
    name: 'tenant-inventory-stocktake',
    component: () => import('@/pages/tenant/inventory/stocktake.vue'),
    meta: { auth: 'tenant', layout: 'default' },
  },
  {
    path: '/tenant/inventory/movements',
    name: 'tenant-inventory-movements',
    component: () => import('@/pages/tenant/inventory/movements.vue'),
    meta: { auth: 'tenant', layout: 'default' },
  },
  // ── SUPPLIERS MODULE ────────────────────────────────
  {
    path: '/tenant/suppliers',
    name: 'tenant-suppliers',
    component: () => import('@/pages/tenant/suppliers/index.vue'),
    meta: { auth: 'tenant', layout: 'default' },
  },
  {
    path: '/tenant/suppliers/orders',
    name: 'tenant-suppliers-orders',
    component: () => import('@/pages/tenant/suppliers/orders.vue'),
    meta: { auth: 'tenant', layout: 'default' },
  },
  // ── CRM MODULE ───────────────────────────────────────
  {
    path: '/tenant/customers',
    name: 'tenant-customers',
    component: () => import('@/pages/tenant/customers/index.vue'),
    meta: { auth: 'tenant', layout: 'default' },
  },
  // ── LOYALTY MODULE ───────────────────────────────────
  {
    path: '/tenant/loyalty',
    name: 'tenant-loyalty',
    component: () => import('@/pages/tenant/loyalty/index.vue'),
    meta: { auth: 'tenant', layout: 'default' },
  },
  {
    path: '/tenant/loyalty/settings',
    name: 'tenant-loyalty-settings',
    component: () => import('@/pages/tenant/loyalty/settings.vue'),
    meta: { auth: 'tenant', layout: 'default' },
  },
  // ── WORKFORCE MODULE ────────────────────────────────
  {
    path: '/tenant/workforce/scheduling',
    name: 'tenant-workforce-scheduling',
    component: () => import('@/pages/tenant/workforce/scheduling.vue'),
    meta: { auth: 'tenant', layout: 'default' },
  },
  {
    path: '/tenant/workforce/attendance',
    name: 'tenant-workforce-attendance',
    component: () => import('@/pages/tenant/workforce/attendance.vue'),
    meta: { auth: 'tenant', layout: 'default' },
  },
  {
    path: '/tenant/workforce/payroll',
    name: 'tenant-workforce-payroll',
    component: () => import('@/pages/tenant/workforce/payroll.vue'),
    meta: { auth: 'tenant', layout: 'default' },
  },
  // ── STAFF MODULE ────────────────────────────────────
  {
    path: '/tenant/users',
    name: 'tenant-users',
    component: () => import('@/pages/tenant/users/index.vue'),
    meta: { auth: 'tenant', layout: 'default' },
  },
  {
    path: '/tenant/users/roles',
    name: 'tenant-users-roles',
    component: () => import('@/pages/tenant/users/roles.vue'),
    meta: { auth: 'tenant', layout: 'default' },
  },
  // ── REPORTS MODULE ───────────────────────────────────
  {
    path: '/tenant/reports/daily',
    name: 'tenant-reports-daily',
    component: () => import('@/pages/tenant/reports/daily.vue'),
    meta: { auth: 'tenant', layout: 'default' },
  },
  {
    path: '/tenant/reports/advanced',
    name: 'tenant-reports-advanced',
    component: () => import('@/pages/tenant/reports/advanced.vue'),
    meta: { auth: 'tenant', layout: 'default' },
  },
  {
    path: '/tenant/reports/shifts',
    name: 'tenant-reports-shifts',
    component: () => import('@/pages/tenant/reports/shifts.vue'),
    meta: { auth: 'tenant', layout: 'default' },
  },
  {
    path: '/tenant/reports/expenses',
    name: 'tenant-reports-expenses',
    component: () => import('@/pages/tenant/reports/expenses.vue'),
    meta: { auth: 'tenant', layout: 'default' },
  },
  {
    path: '/tenant/reports/tax',
    name: 'tenant-reports-tax',
    component: () => import('@/pages/tenant/reports/tax.vue'),
    meta: { auth: 'tenant', layout: 'default' },
  },
  {
    path: '/tenant/reports/cashflow',
    name: 'tenant-reports-cashflow',
    component: () => import('@/pages/tenant/reports/cashflow.vue'),
    meta: { auth: 'tenant', layout: 'default' },
  },
  {
    path: '/tenant/reports/foodcost',
    name: 'tenant-reports-foodcost',
    component: () => import('@/pages/tenant/reports/foodcost.vue'),
    meta: { auth: 'tenant', layout: 'default' },
  },
  {
    path: '/tenant/reports/payroll',
    name: 'tenant-reports-payroll',
    component: () => import('@/pages/tenant/reports/payroll.vue'),
    meta: { auth: 'tenant', layout: 'default' },
  },
  // ── SETTINGS MODULE ─────────────────────────────────
  {
    path: '/tenant/settings',
    name: 'tenant-settings',
    component: () => import('@/pages/tenant/settings/index.vue'),
    meta: { auth: 'tenant', layout: 'default' },
  },
  {
    path: '/tenant/settings/profile',
    name: 'tenant-settings-profile',
    component: () => import('@/pages/tenant/settings/profile.vue'),
    meta: { auth: 'tenant', layout: 'default' },
  },
  {
    path: '/tenant/settings/tax',
    name: 'tenant-settings-tax',
    component: () => import('@/pages/tenant/settings/tax.vue'),
    meta: { auth: 'tenant', layout: 'default' },
  },
  {
    path: '/tenant/settings/receipt',
    name: 'tenant-settings-receipt',
    component: () => import('@/pages/tenant/settings/receipt.vue'),
    meta: { auth: 'tenant', layout: 'default' },
  },
  {
    path: '/tenant/settings/pos',
    name: 'tenant-settings-pos',
    component: () => import('@/pages/tenant/settings/pos.vue'),
    meta: { auth: 'tenant', layout: 'default' },
  },
  {
    path: '/tenant/settings/payroll',
    name: 'tenant-settings-payroll',
    component: () => import('@/pages/tenant/settings/payroll.vue'),
    meta: { auth: 'tenant', layout: 'default' },
  },
  {
    path: '/tenant/settings/crm',
    name: 'tenant-settings-crm',
    component: () => import('@/pages/tenant/settings/crm.vue'),
    meta: { auth: 'tenant', layout: 'default' },
  },
  {
    path: '/tenant/billing-access',
    name: 'tenant-billing-access',
    component: () => import('@/pages/tenant/billing-access.vue'),
    meta: { auth: 'tenant', layout: 'default' },
  },
  {
    path: '/:pathMatch(.*)*',
    component: () => import('@/pages/[...error].vue'),
    meta: { layout: 'blank' },
  },
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
  scrollBehavior(to) {
    if (to.hash)
      return { el: to.hash, behavior: 'smooth', top: 60 }
    
    return { top: 0 }
  },
})

// Auth guard
router.beforeEach(async to => {
  try {
    const isPublic = to.meta.public === true

    if (isPublic) return

    if (to.path.startsWith('/superadmin')) {
      // Lazy-import to avoid circular dependency at module load time
      const { useSaAuthStore } = await import('@/stores/saAuth.js')
      const saAuth = useSaAuthStore()

      if (saAuth && !saAuth.user) {
        await saAuth.fetchUser()
      }

      if (!saAuth?.user) {
        return '/superadmin/login'
      }
    } else if (to.path.startsWith('/tenant')) {
      const { useTenantAuthStore } = await import('@/stores/tenantAuth.js')
      const tenantAuth = useTenantAuthStore()

      // Allow suspended page without any auth check
      if (to.path === '/tenant/suspended') return

      if (tenantAuth && !tenantAuth.user) {
        await tenantAuth.fetchUser()
      }

      if (!tenantAuth?.user) {
        return '/tenant/login'
      }

      // Hard block for suspended — send to lockout screen
      if (tenantAuth?.blockedStatus === 'suspended') {
        return '/tenant/suspended'
      }
    }
  } catch (err) {
    console.error('[Router Guard] Error:', err)
    // Allow navigation to proceed, errors will be handled at component level
  }
})

export { router }
export default function (app) {
  app.use(router)
}
